import { AdminType, APIGet, APIPost, APIPut, APIUrl, APIDelete } from "api/protocols";
import { CancelToken } from "axios";
import { IRegister } from "pages/secure/facility/Admin";

// const apiVersion = "2024-04";
// const adminType = "facility-admin";
// const baseRegisterUrl = "/" + apiVersion + "/" + adminType + "/facility/register";

export type TGetRegister = {
  id?: number;
  extended?: boolean;
  active_shift?: boolean;
};

export async function GetRegisters(params: TGetRegister, useGlobalLoader?: boolean, token?: CancelToken) {
  return await APIGet<IRegister[]>(
    APIUrl(AdminType.FacilityAdmin, "/facility/register"),
    params,
    useGlobalLoader,
    token,
  );
}

export async function PutRegister(params: any, useGlobablLoader?: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/facility/register"), params, useGlobablLoader);
}

export async function PostRegister(
  params: { register_group_id?: null | number; default_card_reader_id?: null | number; title: string },
  useGlobablLoader?: boolean,
) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/facility/register"), params, useGlobablLoader);
}

export async function GetRegisterAdjustments(params: { id?: number, register_ids?: number[], date?: string }, useGlobalLoader?: boolean, token?: CancelToken) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/facility/register/adjustment"), params, useGlobalLoader, token);
}

export type TPostRegisteradjustment = {
  register_id: number;
  date: string;
  amount: number;
  reason?: string;
  payment_accounting_reference_id?: number;
  offsetting_accounting_reference_id?: number;
}

export type TPutRegisterAdjustment = TPostRegisteradjustment & {
  id: number;
}

export async function PostRegisterAdjustment(params: TPostRegisteradjustment, useGlobalLoader?: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/facility/register/adjustment"), params, useGlobalLoader);
}

export async function PutRegisterAdjustment(params: TPutRegisterAdjustment, useGlobalLoader?: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/facility/register/adjustment"), params, useGlobalLoader);
}

export async function DeleteRegisterAdjustment(params: { id: number }, useGlobalLoader?: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/facility/register/adjustment"), params, useGlobalLoader);
}